var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"order-positions-list"},_vm._l((_vm.positions),function(position){return _c('li',{key:position.id,staticClass:"order-positions-list__item"},[[_vm._t("position",null,{"position":position})]],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }